<template>
  <section class="content">
    <!-- Cabecera -->
    <section class="content-header">
      <!-- … tu markup … -->
    </section>

    <div class="container-fluid">
      <!-- Botón “Agregar” -->
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div
            id="btn-agregar-almacen"
            class="info-box mb-3"
            @click="nuevoAlmacen()"
          >
            <a
              href="javascript:void(0)"
              class="btn btn-block info-box-icon bg-info elevation-1"
            >
              <i class="fas fa-plus"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Almacén</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div
            id="btn-descargar-pdf"
            class="info-box mb-3"
            @click="descargarPDF()"
            style="cursor: pointer;"
          >
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-danger elevation-1">
              <i class="fas fa-file-pdf"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Descargar PDF</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla generada por DataTables -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">
                Lista de almacenes que puedes administrar
              </h3>
            </div>
            <div class="card-body">
              <table
                id="tablaAlmacen"
                class="table table-bordered table-striped w-100"
              >
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Descripción</th>
                    <th>Empresa</th>
                    <th>Estatus</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
              </table>
              <form-almacen
                :empresas="empresas"
                :almacen="almacenActual"
                @success="obtenerAlmacenes"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick
} from "vue";
import api from "@/services/api";
import FormAlmacen from "@/components/FormAlmacen.vue";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import { tutorial } from "@/plugins/tutorial";

export default {
  components: { FormAlmacen },

  setup() {
    const dt = ref(null);
    const almacenes = ref([]);
    const empresas = ref([]);
    const almacenActual = ref(null);

    // 1) Traer lista de empresas
    async function obtenerEmpresas() {
      const { data } = await api.get("/empresa");
      empresas.value = data;
    }

    // 2) Traer y renderizar tabla de almacenes
    async function obtenerAlmacenes() {
      const { data } = await api.get("/almacen");
      almacenes.value = data;

      await nextTick();

      if (!dt.value && window.$ && $.fn.DataTable) {
        // Inicializar DataTable una sola vez
        dt.value = $("#tablaAlmacen").DataTable({
          data: almacenes.value,
          columns: [
            { data: "codigo",      title: "Código" },
            { data: "descripcion", title: "Descripción" },
            {
              data: "empresa.nombre",
              title: "Empresa",
              defaultContent: ""
            },
            {
              data: "estatus",
              title: "Estatus",
              className: "text-center",
              render: data => data 
                ? '<span class="badge badge-success">Activo</span>' 
                : '<span class="badge badge-danger">Inactivo</span>',
              defaultContent: ""
            },
            {
              data: null,
              title: "Opciones",
              orderable: false,
              className: "text-center",
              render: row => `
                <button
                  class="btn btn-warning btn-sm editar"
                  data-id="${row.id}"
                >
                  <i class="fas fa-pen-to-square"></i>
                </button>
                <button
                  class="btn btn-danger btn-sm eliminar"
                  data-id="${row.id}"
                >
                  <i class="fas fa-trash"></i>
                </button>
              `
            }
          ],
          responsive: true,
          autoWidth: false,
          pageLength: 10,
          lengthChange: false,
          pagingType: "numbers",
          language: {
            url:
              "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
          },
          dom:
            '<"row mb-3"<"col-12 col-md-6"f>>' +
            "t" +
            '<"row mt-3"<"col-12 text-center"i>>' +
            '<"row"<"col-12 d-flex justify-content-center"p>>'
        });

        // Delegación de eventos sobre los botones inyectados
        const table = dt.value;
        $("#tablaAlmacen tbody")
          .on("click", "button.editar", async e => {
            const row = $(e.currentTarget).closest("tr");
            const data = table.row(row).data();
            editarAlmacen(data);
          })
          .on("click", "button.eliminar", async e => {
            const data = table
              .row($(e.currentTarget).closest("tr"))
              .data();
            await eliminarAlmacen(data);
          });
      } else if (dt.value) {
        // Si ya existe el DataTable, solo actualizar datos
        dt.value.clear().rows.add(almacenes.value).draw();
      }
    }

    // 3) Funciones de CRUD
    function nuevoAlmacen() {
      almacenActual.value = null;
      nextTick(() => $("#almacenModal").modal("show"));
    }

    function editarAlmacen(alm) {
      almacenActual.value = alm;
      console.log(almacenActual)
      nextTick(() => $("#almacenModal").modal("show"));
    }

    async function descargarPDF() {
      try {
        loading.show('Generando PDF...');
        const response = await api.get("/pdf/almacenes", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Almacenes.pdf');
        document.body.appendChild(link);
        link.click();
        loading.hide();
      } catch (error) {
        loading.hide();
        alert.show({ title: 'Error', text: 'No se pudo generar el PDF', icon: 'error' });
      }
    }

    async function eliminarAlmacen(alm) {
      const confirmacion = await alert.show({
        title: '¿Estás seguro?',
        text: `¿Seguro que quieres eliminar "${alm.descripcion}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (confirmacion.isConfirmed) {
        try {
          loading.show('Procesando solicitud...');
          await api.delete(`/almacen/${alm.id}`);
          almacenes.value = almacenes.value.filter(x => x.id !== alm.id);
          dt.value.clear().rows.add(almacenes.value).draw();
          loading.hide();
          alert.toast({ title: 'Almacén eliminado correctamente', icon: 'success' });
        } catch (error) {
          loading.hide();
          const msg = error.response?.data?.message || 'No se pudo eliminar el almacén.';
          alert.show({ title: 'Error', text: msg, icon: 'error' });
        }
      }
    }

    // 4) Tutorial
    function iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-almacen',
          title: 'Nuevo Almacén',
          text: 'Haz clic en este recuadro para registrar un nuevo almacén.',
          position: 'bottom'
        },
        {
          element: '#btn-descargar-pdf',
          title: 'Descargar Reporte',
          text: 'Haz clic aquí para generar un archivo PDF con la lista de todos los almacenes.',
          position: 'bottom'
        },
        {
          element: '.card-body',
          title: 'Listado de Almacenes',
          text: 'Aquí verás la lista de almacenes registrados.',
          position: 'top'
        }
      ];

      const table = $('#tablaAlmacen');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');

        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '#tablaAlmacen tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) o en la primera columna para ver los datos ocultos y las acciones.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function() {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if ($(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });

        steps.push({
          element: '.dtr-details .editar',
          title: 'Editar Almacén',
          text: 'Haz clic en el botón amarillo para modificar los datos de un almacén existente.',
          position: 'left'
        });

        steps.push({
          element: '.dtr-details .eliminar',
          title: 'Eliminar Almacén',
          text: 'Haz clic en el botón rojo para eliminar un almacén. Esta acción requiere confirmación.',
          position: 'left'
        });
      } else {
        steps.push({
          element: '.editar',
          title: 'Editar Almacén',
          text: 'Haz clic en el botón amarillo para modificar los datos de un almacén existente.',
          position: 'left'
        });

        steps.push({
          element: '.eliminar',
          title: 'Eliminar Almacén',
          text: 'Haz clic en el botón rojo para eliminar un almacén. Esta acción requiere confirmación.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }

    // 4) Ciclo de vida
    onMounted(() => {
      obtenerEmpresas();
      obtenerAlmacenes();
      tutorial.set(iniciarTutorial);
    });

    onBeforeUnmount(() => {
      if (dt.value) {
        dt.value.destroy();
        dt.value = null;
      }
      tutorial.set(null);
    });

    return {
      almacenes,
      empresas,
      almacenActual,
      nuevoAlmacen,
      editarAlmacen,
      descargarPDF,
      eliminarAlmacen,
      obtenerAlmacenes,
    };
  }
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>